import { z } from 'zod';
import { ValidationPatterns } from './shared/common';
const BaseAuthUserSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: ValidationPatterns.email,
  picture: z.string(),
  stripeCustomerId: z.string().optional(),
});
export const AuthUserSchemas = {
  full: BaseAuthUserSchema,
  public: BaseAuthUserSchema.omit({
    email: true,
    stripeCustomerId: true,
  }),
  authResponse: BaseAuthUserSchema.pick({
    id: true,
    name: true,
    email: true,
    picture: true,
  }),
};
export const GoogleAuthResponseSchema = z.object({
  token: z.string(),
  user: AuthUserSchemas.authResponse,
});
export const LogoutResponseSchema = z.object({
  message: z.string(),
});
export const AuthRequestSchemas = {
  googleAuth: z.object({
    token: z
      .string()
      .min(1, 'Google token is required')
      .max(2048, 'Google token too long')
      .regex(/^[A-Za-z0-9._-]+$/, 'Invalid Google token format'),
  }),
  logout: z.object({}),
};
export const AuthAPI = {
  googleAuth: {
    request: AuthRequestSchemas.googleAuth,
    response: GoogleAuthResponseSchema,
  },
  logout: {
    request: AuthRequestSchemas.logout,
    response: LogoutResponseSchema,
  },
};
export type AuthUser = z.infer<typeof AuthUserSchemas.full>;
export type PublicAuthUser = z.infer<typeof AuthUserSchemas.public>;
export type AuthResponseUser = z.infer<typeof AuthUserSchemas.authResponse>;
export type GoogleAuthResponse = z.infer<typeof GoogleAuthResponseSchema>;
export type LogoutResponse = z.infer<typeof LogoutResponseSchema>;
export type GoogleAuthRequest = z.infer<typeof AuthRequestSchemas.googleAuth>;
export type LogoutRequest = z.infer<typeof AuthRequestSchemas.logout>;
export type AuthApiGoogleAuthRequest = z.infer<
  typeof AuthAPI.googleAuth.request
>;
export type AuthApiGoogleAuthResponse = z.infer<
  typeof AuthAPI.googleAuth.response
>;
export type AuthApiLogoutRequest = z.infer<typeof AuthAPI.logout.request>;
export type AuthApiLogoutResponse = z.infer<typeof AuthAPI.logout.response>;
